import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Systems.css';

const Systems = () => {
  const { language } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="solutions-approved" id="services">
      <div className="container">
        <div className="solutions-approved-grid">
          <div className="solutions-intro">
            <div className="solutions-label">
              {language === 'es' ? 'NUESTRAS SOLUCIONES' : 'OUR SOLUTIONS'}
            </div>
            <h2 className="solutions-headline">
              {language === 'es'
                ? 'Soluciones digitales integradas para hacer crecer tu negocio'
                : 'Integrated digital solutions to grow your business'}
            </h2>
            <p className="solutions-description">
              {language === 'es'
                ? 'Combinamos tecnología, automatización y estrategia digital para resolver problemas reales en tu operación.'
                : 'We combine technology, automation and digital strategy to solve real problems in your operation.'}
            </p>
            <button onClick={() => scrollToSection('projects')} className="solutions-cta">
              <span>{language === 'es' ? 'Ver todas las soluciones' : 'See all solutions'}</span>
              <ArrowRight size={18} />
            </button>
          </div>

          <div className="solution-card-approved">
            <div className="card-header-image">
              <img src="/presencia-header-HD.png" alt="Presencia Digital" className="header-illustration" />
            </div>
            <div className="card-body-approved">
              <div className="card-platform-icons">
                <div className="platform-icon-circle" style={{background: '#4285F4', zIndex: 4}}>G</div>
                <div className="platform-icon-circle" style={{background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)', zIndex: 3, marginLeft: '-12px'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073z"/>
                  </svg>
                </div>
                <div className="platform-icon-circle" style={{background: '#1877f2', zIndex: 2, marginLeft: '-12px'}}>f</div>
                <div className="platform-icon-circle" style={{background: '#25d366', zIndex: 1, marginLeft: '-12px'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884"/>
                  </svg>
                </div>
              </div>
              <h3 className="card-title-approved">
                {language === 'es' ? 'Presencia Digital Conectada' : 'Connected Digital Presence'}
              </h3>
              <p className="card-description-approved">
                {language === 'es'
                  ? 'Conectamos los canales digitales de tu negocio para que más personas te encuentren, te conozcan y te contacten.'
                  : 'We connect your business digital channels so more people can find you, know you and contact you.'}
              </p>
              <button onClick={() => scrollToSection('projects')} className="card-link-approved">
                {language === 'es' ? 'Ver más' : 'Learn more'} →
              </button>
            </div>
          </div>

          <div className="solution-card-approved">
            <div className="card-header-image">
              <img src="/gestion-header-HD.png" alt="Gestión Digital" className="header-illustration" />
            </div>
            <div className="card-body-approved">
              <div className="card-platform-icons">
                <div className="platform-icon-circle" style={{background: '#0078D4', zIndex: 4}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>
                </div>
                <div className="platform-icon-circle" style={{background: '#7C4DFF', zIndex: 3, marginLeft: '-12px'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/></svg>
                </div>
                <div className="platform-icon-circle" style={{background: '#0066FF', zIndex: 2, marginLeft: '-12px'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"/></svg>
                </div>
                <div className="platform-icon-circle" style={{background: '#0364B8', zIndex: 1, marginLeft: '-12px'}}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
                </div>
              </div>
              <h3 className="card-title-approved">
                {language === 'es' ? 'Gestión Digital Conectada' : 'Connected Digital Management'}
              </h3>
              <p className="card-description-approved">
                {language === 'es'
                  ? 'Organizamos información y automatizamos procesos para que tu equipo trabaje mejor y con menos esfuerzo.'
                  : 'We organize information and automate processes so your team works better with less effort.'}
              </p>
              <button onClick={() => scrollToSection('projects')} className="card-link-approved">
                {language === 'es' ? 'Ver más' : 'Learn more'} →
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Systems;